import { Injectable } from '@angular/core';
import { ActiveJobs } from '../domain/activeJobs';
import { Job } from "../domain/job";
import { JobLog } from '../domain/JobLog';
import { InsertJob } from '../domain/InsertJob';

export const JOBS_URI = 'jobs';
export const JOB_URI = 'job';
export const ARTICLE_URI = '/article';
export const DEVIATION_LIMIT = 120;

// Status received from AS/400 jobs
export const STATUS_COMPLETE = 'Normal completion';
export const STATUS_FAILED = 'Abnormal termination';
export const STATUS_RUNNING = 'Running';
export const STATUS_HOLD = 'On hold';
export const STATUS_MESSAGE_WAITING = 'Message waiting';
export const STATUS_FORECAST = 'Forecast';

export const APP_NAME = 'FC IT Enhanced Suite Tools Application (FIESTA)';
export const APP_NAME_MOBILE = 'FIESTA';
export const APP_CODE_CONTEXTUAL = 'fsta';


// Routing Handler
export const HOME_PAGE = 'home';
export const JOB_DEFINITION_PAGE = 'jobDefinition';
export const JOB_LOG_PAGE = 'jobLog';
export const LOGIN_PAGE = 'login';
export const AUTH_ERROR_PAGE = 'auth-error';
export const EXECUTIONS = 'executions';
export const EXECUTIONS_RESOURCE = 'executions/:resource';
export const EXECUTIONS_RESOURCE_APPLICATION = 'executions/:resource/:application';
export const EXECUTIONS_RESOURCE_APPLICATION_LOCATION = 'executions/:resource/:application/:location';
export const EXECUTIONS_RESOURCE_APPLICATION_LOCATION_JOB = 'executions/:resource/:application/:location/:jobname';
export const BUSINESS = 'business';
export const SIDEBAR = 'sb';
export const ACTIVE_JOBS = 'activeJobs';

// Manage colors in status
export const CSS_OK = 'darkgreen';
export const CSS_FAILED = 'firebrick';
export const CSS_WARNING = 'goldenrod';

// Executions ComboBox
export const RESOURCE = 'Select resource';
export const APPLICATION = 'Select application';
export const LOCATION = 'Select location';
export const JOBNAME = 'Select job name';
export const APPLICATIONSHEADER = 'APPLICATIONS';
export const RESOURCEHEADER = 'RESOURCES';
export const LOCATIONHEADER = 'LOCATIONS';
export const JOBNAMEHEADER = 'JOBS';
export const EXECUTIONHEADER = 'EXECUTION DETAILS';


@Injectable()
export class SharedDataService {

  resource: string;
  jodId: string;
  selectedAppFullName: string[];
  selectedLocation: string;
  selectedJobName: string;
  selectedJobUser: string;
  selectedJobNumber: string;
  selectedAuthName: string;
  selectedSubSystem: string[];
  selectedSystem: string[];
  selectedDescription: string;
  selectedStatus: string[];
  selectedStartDate: Date;
  selectedActiveJobStatus: string[];

  rowData: ActiveJobs;
  joblogs: JobLog[];

  tableEvent: any;

  jobPage: number;
  jobSize: number;

  selectedUser: string;
  selectedType: string;

  job: Job;
  jobresource: string;

  // Global constants

  insertJobData(jobdetail: InsertJob) {
    if (jobdetail === null) {
      this.resource = null;
      this.jodId = null;
      this.selectedAppFullName = null;
      this.selectedLocation = null;
      this.selectedJobName = null;
      this.selectedDescription = null;
      this.selectedStatus = null;
      this.selectedStartDate = null;
    } else {
      this.resource = jobdetail.resource;
      this.jodId = jobdetail.jobId;
      this.selectedAppFullName = jobdetail.selectedAppFullName;
      this.selectedLocation = jobdetail.selectedLocation;
      this.selectedJobName = jobdetail.selectedJobName;
      this.selectedDescription = jobdetail.selectedDescription;
      this.selectedStatus = jobdetail.selectedStatus;
      this.selectedStartDate = jobdetail.selectedStartDate;
    }

  }
  insertActiveJobData(selectedJobName: string,
    selectedStatus: string[], selectedJobUser: string, selectedJobNumber: string, selectedAuthName: string, selectedSubSystem: string[], selectedSystem: string[]) {
    this.selectedJobName = selectedJobName;
    this.selectedActiveJobStatus = selectedStatus;
    this.selectedJobUser = selectedJobUser;
    this.selectedJobNumber = selectedJobNumber;
    this.selectedAuthName = selectedAuthName;
    this.selectedSubSystem = selectedSubSystem;
    this.selectedSystem = selectedSystem;

  }

  setJob(job: Job, resource: string) {
    this.job = job;
    this.jobresource = resource;
  }

  // Used fot detail components
  getJob() {
    return this.job;
  }
  getResource() {
    return this.resource;
  }

  resetJob() {
    this.job = null;
  }
  returnHome() {
    this.jodId = null;
  }

  flushJobData() {
    this.resource = null;
    this.jodId = null;
    this.selectedAppFullName = null;
    this.selectedLocation = null;
    this.selectedJobName = null;
    this.selectedDescription = null;
    this.selectedStatus = null;
    this.selectedStartDate = null;
    this.selectedUser = null;
    this.selectedType = null;
  }

}